module.exports = __webpack_public_path__ + "img/png1.1a10b243.png";